module.exports = __webpack_public_path__ + "media/application/images/ui/purchase/consumer-7-day-939d46bddb2f48df9ad902572387c402.png";